import { ModuleWithProviders, NgModule } from '@angular/core';

import { JwksValidationHandler, OAuthService } from 'angular-oauth2-oidc';

import { authPasswordFlowConfig } from './auth-password-flow.config';
import { DISCOVERY_URL } from './auth.tokens';
import { ExtraauthService } from './extraauth.service';
import { LoginGuard } from './login.guard';

@NgModule({
	providers: [ LoginGuard ]
})
export class ExtraauthModule {
	constructor(private _oauthService: OAuthService) {
		this._oauthService.configure(authPasswordFlowConfig);
		this._oauthService.tokenValidationHandler = new JwksValidationHandler();
		this._oauthService.events.filter(e => e.type === 'token_expires').subscribe(() => this._oauthService.refreshToken());
	}

	static forRoot(): ModuleWithProviders {
		return {
			ngModule: ExtraauthModule,
			providers: [
				{provide: DISCOVERY_URL, useValue: 'https://oauth.go-suite.com/.well-known/openid-configuration'},
				ExtraauthService,
			],
		};
	}
}



// WEBPACK FOOTER //
// ./src/app/login/extraauth.module.ts